const notesLandingPage = {
  title: 'Anteckningar',
  infoTitle: 'Anteckning',
  description: 'Välj att göra en ny anteckning eller visa äldre anteckningar',
  showOlder: 'Visa äldre anteckningar'
}

export default notesLandingPage
